// src/api/benefits.js
import * as request from '@/utils/request'

export function getBenefits() {
  return request.get('/vip/benefits')  // 如果后端接口就是 /vip/benefits
}